import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Mode } from '../../constants/enums';

const useStyles = makeStyles((theme: Theme) => ({
  tickets: {
    width: '100%',
    height: '100%',
    padding: '10px',
    boxSizing: 'border-box',
    gap: '10px',
    overflow: 'hidden',
    maxWidth: '1750px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
  },
  filterGroupHeader: {
    color: theme.palette.text.primary,
    margin: '5px 0',
    textTransform: 'uppercase',
    fontWeight: 800,
  },
  filtersList: { display: 'flex', gap: '5px', flexDirection: 'column' },
  activeFilter: {
    background: 'var(--color-primary)',
    color: 'white !important',
    '& svg': { '& path': { fill: 'white !important' } },
  },
  filter: {
    '&.MuiButtonBase-root': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: theme.palette.text.primary,
      cursor: 'pointer',
      padding: '5px 15px',
      boxSizing: 'border-box',
      borderRadius: '10px !important',
      border: 'none',
    },
    '& svg': { width: '20px', '& path': { fill: theme.palette.text.primary } },
  },
  filterName: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 800,
    gap: '10px',
  },
  ticketsContent: {
    display: 'grid',
    gridTemplateRows: '90px 1fr 60px',
    gap: '20px',
    height: '100%',
    overflow: 'hidden',
  },
  searchContainer: {
    padding: '0px',
    borderRadius: '15px',
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    maxHeight: '70px',
    alignItems: 'center',
  },
  ticketsTable: {
    flex: '1 1 auto',
    minHeight: 0,
    '& .MuiPaper-root': {
      backgroundColor: theme.palette.mode === Mode.Dark ? '#3a3a3a !important' : undefined,
    },
  },
  ticketsPagination: {
    flex: '0 0 auto',
    maxHeight: '70px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
  },
  ticketsList: {
    background: theme.palette.background.paper,
    padding: '20px',
    borderRadius: '15px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    overflow: 'auto',
    maxHeight: '56vh',
  },
  ticketListHeader: { display: 'flex', justifyContent: 'space-between' },
  ticketsStats: {
    display: 'flex',
    gap: '10px',
    color: theme.palette.text.primary,
    fontWeight: 800,
    fontSize: '14px',
    alignItems: 'center',
    width: '100%',
    '& svg': {
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      '& path': {
        stroke: theme.palette.text.primary,
      },
    },
  },
  ticketStatsClosed: {
    color: 'grey',
  },
  ticketsListLoading: {
    width: '30px',
    height: '30px',
  },
  ticketListItemStatus: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    color: theme.palette.text.primary,
    '& svg': { '& path': { fill: theme.palette.text.primary } },
  },
  ticketListItem: {
    padding: '5px 10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #d4d4d452',
    borderRadius: '5px',
    cursor: 'pointer',
    '&:hover': { borderColor: '#00000061', boxShadow: '0 0 1px 1px #0000001c' },
    '& svg': { width: '30px', height: '30px' },
  },
  ticketListItemTitle: {
    fontWeight: 800,
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: '10px',
    color: theme.palette.text.primary,
  },
  id: { color: 'grey', fontWeight: 400 },
  searchIcon: {
    width: '24px',
    height: '24px',
    marginRight: '8px',
    '& path': {
      fill:
        theme.palette.mode === Mode.Dark ? theme.palette.common.white : theme.palette.common.black,
    },
  },
  saveButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '10px',
  },
  chatButtonWrapper: {
    display: 'flex',
    gap: '4px',
    justifyContent: 'flex-end',
    width: '100%',
    '& svg': { width: '30px', height: '30px', cursor: 'pointer' },
    '& path': {
      stroke:
        theme.palette.mode === Mode.Dark ? theme.palette.common.white : undefined,
    },
  },
  table: { '& tbody': { maxHeight: '38vh' } },
  link: {
    textDecoration: 'none',
    fontWeight: 700,
    color: theme.palette.mode === Mode.Dark ? '#4DA3FF !important' : undefined,
  },
  searchContainerFields: {
    width: '300px',
  },
}));

export default useStyles;
